export default __webpack_public_path__ + "static/media/Img_charge_controllers.95656f28.svg";